// Lightweight GA4 event helper. gtag is loaded globally in public/index.html.
export const trackEvent = (name, params = {}) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", name, params);
  }
};

const SOURCE_KEY = "cb_calc_entry_source";

// Records how the user entered the calculator (e.g. "service_hail-damage",
// "popular_roof", "funnel_roof-claim-calculator_hero"). Persists for the
// session so the downstream calculator events can attribute the full path
// from SEO landing page → calculator → lead.
export const setCalcEntrySource = (source) => {
  if (typeof window !== "undefined" && window.sessionStorage) {
    try {
      window.sessionStorage.setItem(SOURCE_KEY, source);
    } catch (e) {
      /* ignore storage errors */
    }
  }
};

export const getCalcEntrySource = () => {
  if (typeof window !== "undefined" && window.sessionStorage) {
    try {
      return window.sessionStorage.getItem(SOURCE_KEY) || "direct";
    } catch (e) {
      return "direct";
    }
  }
  return "direct";
};

// Fires a click event AND stores the entry source in one call.
export const trackCalcEntry = (eventName, source, extra = {}) => {
  setCalcEntrySource(source);
  trackEvent(eventName, { entry_source: source, ...extra });
};
